"use client";

import React from "react";

interface AgentStatusDotProps {
  variant?: "primary" | "muted";
  className?: string;
}

/**
 * Small pulsing dot for status indicators. Theme is encapsulated via variant.
 */
export default function AgentStatusDot({
  variant = "primary",
  className,
}: AgentStatusDotProps) {
  const bgClass = variant === "primary" ? "bg-primary" : "bg-muted-foreground";
  return (
    <div
      className={`w-1.5 h-1.5 rounded-full animate-pulse shrink-0 ${bgClass} ${className ?? ""}`}
      aria-hidden
    />
  );
}
